import { render } from "./networkFollow.vue?vue&type=template&id=628e618d&scoped=true"
import script from "./networkFollow.vue?vue&type=script&lang=js"
export * from "./networkFollow.vue?vue&type=script&lang=js"

import "./networkFollow.vue?vue&type=style&index=0&id=628e618d&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628e618d"]])

export default __exports__